import React from 'react';
import * as S from './styles';

const VideoLightbox = ({ children, handleClose = () => {} }) => (
    <S.Background onClick={() => handleClose()}>
        {children}
    </S.Background>
);

export default VideoLightbox;
